import { AICampaignIcon } from 'features/AICampaign/AICampaignIcon';
import { AICampaign } from 'features/AICampaign/interface';
import { useState } from 'react';
import { AppTheme } from 'shared/constants/common';
import useResolvedColorScheme from 'shared/hooks/useResolvedColorScheme';
import { isMobile } from '../../util/utility';

interface ToggleSwitchProps {
	onChange: (value: boolean) => void;
	initialValue?: boolean;
}
const CategoriesToggle = ({ onChange, initialValue = false }: ToggleSwitchProps) => {
	const [active, setActive] = useState(initialValue);
	const { resolvedColorScheme } = useResolvedColorScheme();

	const toggleSwitch = () => {
		const newValue = !active;
		setActive(newValue);
		onChange(newValue);
	};

	return (
		<div className={`toggle-wrapper ${active && 'toggle-wrapper-active'}`} onClick={toggleSwitch} data-cy="live-switcher">
			{isMobile() && (
				<>
					<AICampaignIcon selectedOption={AICampaign.AI} location="tabs-left" />
					<AICampaignIcon selectedOption={AICampaign.INTUITION} location="tabs-right" />
				</>
			)}

			<div className={`toggle-circle ${active && 'toggle-circle-active'}`} />
			<div
				className="toggle-element"
				style={{
					color: active && resolvedColorScheme === AppTheme.LIGHT ? '#004D43' : 'white',
				}}
			>
				{isMobile() && 'Popularne'}
			</div>
			<div
				className="toggle-element"
				style={{
					color: active ? 'white' : 'red',
				}}
			>
				{isMobile() && 'Live'}
			</div>
		</div>
	);
};

export default CategoriesToggle;
